// extracted by css-extract-rspack-plugin
export default {"card":"znaii","table":"ReoTg","row":"amR2M","readOnly":"G4x6Y","action":"Vb8_C","rowEditor":"ijj2D","input":"WpNHu","inputError":"vkhLE"};